import React, { Component } from 'react';
import { Col, NavLink, Form, FormGroup, Row } from 'reactstrap';
import DeleteModal from "components/FDModal/delete-save-card";
import { connect } from 'react-redux';
import { reduxForm, Field, getFormValues } from 'redux-form'
import { RenderForm, CardImage, SaveCardAutoInfo, filterSCByBankName } from 'components/Common'
import { callCardMetaDataAPI, callDeleteSavedCard, callSetPayment } from 'actions/payment'
import { scFormValidation } from 'lib/fp-validation'
import GlobalLoaderModal from "components/FDModal/global-loader";
import { numberAndUpdateCvv, formatCardWithSpace, cvvMaxLength, onDropAlphawithsinglespace, isEmptyOrUndefined, avoidPasting } from 'lib/fp-utility';
import SIBtnORBtn from "components/Common/siProceedBtn";
import OTPModal from "components/FDModal/card-otp";
import DisplayError from "components/FDModal/display-error";

class SavedCardForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loader: false,
            deleteConfirm: false,
            enableDelete: false,
            selectedCard: null,
            selectedDeleteCard: null,
            activeCardCVV: null,
            isActive: false,
            redirectingTOBank: true,
            siEnabled: false,
            cvv_pin: false
        }
        this.handleDelete = this.handleDelete.bind(this);
        this.toggleDelete = this.toggleDelete.bind(this);
        this.currentCard = this.currentCard.bind(this);
        this.payUsingSavedCard = this.payUsingSavedCard.bind(this);
        this.closeSelfOTP = this.closeSelfOTP.bind(this);
        this.deleteSavedCard = this.deleteSavedCard.bind(this)
        this.canDisplayErrorModal = this.canDisplayErrorModal.bind(this)
        this.handlePaste = this.handlePaste.bind(this)
        this.handleSiEnabledChecked = this.handleSiEnabledChecked.bind(this)
        this.canDisplaySICheckbox = this.canDisplaySICheckbox.bind(this)
        this.filterSavedCard = this.filterSavedCard.bind(this);
        this.updateCvv = this.updateCvv.bind(this);
        this.getCvv = this.getCvv.bind(this);
    }

    componentDidMount(){
        const {transactionDetails} = this.props;
        if(this.props.from==='EMISC'){
            this.props.change("sc[emiTenure]", this.props.emiTenure)
            this.props.change("bankName", this.props.bankname)
            this.props.change("bankCode", this.props.bankcode)
        }
        if(transactionDetails &&
            transactionDetails.autoDebit 
            ){
             if(transactionDetails.autoDebit === "Y"){
                 this.setState({siEnabled: true})
             }else{
                 this.setState({siEnabled: false})
             }
       
         }
    }

    deleteSavedCard(){
        let merchantId = this.props.globalConfig.mConfig.merchantId ? this.props.globalConfig.mConfig.merchantId : null
        this.setState({deleteConfirm: true, loader: true, redirectingTOBank: false})
        this.props.callDeleteSavedCard(this.state.selectedDeleteCard.hostedId, merchantId)
        .then((resp)=>{
            this.setState({deleteConfirm: false, loader: false})
            const result = resp.payload.data;
            if(result.status==='SUCCESS'){
                this.clearAllInput(this.state.selectedDeleteCard.hostedId)
                this.setState({deleteConfirm: false})
            }
        }).catch((error)=>{
            this.setState({deleteConfirm: false, loader: false})
        })
    }

    async payUsingSavedCard(scValues){
        this.setState({loader: true, redirectingTOBank: true})
        this.props.callSetPayment(this.props.from, scValues, this.props.txnKey, this.props.txnIv).then((resp)=>{
            this.setState({paymentResponse: resp.payload.data})
            const { errorCode, errorMessage, selfOTPBin, selfOTPTermUrl, is3DSecure, isRupayCard, threeDSecureRequest, rupayCardRequestBean } = resp.payload.data
            const non3DSecure = !(selfOTPBin || is3DSecure || isRupayCard)
            this.setState({is3DSecure, selfOTPBin, selfOTPTermUrl, isRupayCard, threeDSecureRequest, rupayCardRequestBean, non3DSecure})
            if(errorCode){
                this.setState({loader: false})
                this.canDisplayErrorModal(errorCode, errorMessage)
            }else if(selfOTPBin){
                this.setState({loader: false})
            }else if(is3DSecure){
                this.setState({redirectingTOBank: true})
                if(!threeDSecureRequest.is3ds2Integration) {
                    document.ACSFORM.submit();
                } else {
                    if(threeDSecureRequest.tdsFlow === 'CHL') {
                        document.creq.submit();
                    }
                }                
            }else if(non3DSecure){
                this.setState({non3DSecureUrl: resp.payload.data.redirectUrl, redirectingTOBank: true})
                document.NON3DSECUREFORM.submit();
            }
        }).catch((error) => {
            this.setState({loader: false})
            // console.log("SCSubmit Err: ", error)
        })
    }

    async currentCard(cvv, card){
        if(cvv.length===0){
            this.clearAllInput(card.hostedId)
            return false
        }else if(cvv.length>2){
            const card_no = card.alias.slice(0,6)
            const { bankname, bankcode } = this.props
            const forMetaData = {card_no, bankname, bankcode }
            await callCardMetaDataAPI(this.props.from, forMetaData)
            .then((resp) => {
                if(resp.data.response.errorCode){
                    this.setState({cardMetaData: null, cardScheme: null, cardType: null, siEnabled: false, dccEnabled: false, dccCard: null})
                    this.props.change('standingInstruction', '')
                    this.canDisplayErrorModal(resp.data.response.errorCode, resp.data.response.errorMessage)
                }else{
                    const { cardScheme, cardType } = resp.data.response.cardDetail
                    this.setState({cardMetaData: resp.data.response, cardScheme, cardType, dccEnabled: !isEmptyOrUndefined(resp.data.response.dcc), dccCard: resp.data.response.dcc})
                }
            })
        }
        this.props.change("sc[hostedId]", card.hostedId)
        this.props.change("sc[emiTenure]", this.props.emiTenure)
        this.props.change("cardNo", card.alias)
    }

    toggleDelete(){
        const currentState = this.state.isActive;
        this.setState({
            isActive: !currentState,
            enableDelete: !this.state.enableDelete
        })
    }

    clearAllInput(id){
        this.props.change("sc[cvv]", '')
        this.props.savedCards && this.props.savedCards.map((sc, i)=>{
            this.props.change(`cvv${i}`, '')
            return null
        })
        this.setState({focus: id, selectedCard: null, cardMetaData: null, cardScheme: null, cardType: null, siEnabled: false, dccEnabled: false, dccCard: null})
        this.props.change('standingInstruction', '')
        const inputElements = document.getElementsByClassName('scCvvInput')
        if(inputElements){
            for (var i=0; i < inputElements.length; i++) {
                inputElements[i].value = '';
            }
        }
    }

    async handleDelete(card) {
        await this.setState({selectedDeleteCard: card, deleteConfirm: true})
        document.body.dispatchEvent(new CustomEvent('DeleteCard', { detail: true }));
    }

    closeSelfOTP(){
        this.setState({selfOTPBin: false})
    }

    canDisplayErrorModal(errCode, errMsg){
        if(errCode==='FPDR4025'){
            this.setState({displayError: true, errMsg})
        }
    }

    handlePaste(e){
        e.preventDefault();
        return false;
    }
    
    handleSiEnabledChecked(e){
        this.setState({siEnabled: !this.state.siEnabled})
    }

    canDisplaySICheckbox(){
        return this.props.siEnabled && this.props.from==='SC' && this.state.cardType==='CREDIT'
    }
    
    filterSavedCard(){
        const { savedCards, from, bankname } = this.props
        if(isEmptyOrUndefined(savedCards)){
            return []
        }else{
            return from==='EMISC' ? filterSCByBankName(savedCards, bankname) : savedCards
        }
    }

    updateCvv(v){
        this.props.change("sc[cvv]", v)
    }

    getCvv(v){
        return (this.props.formValues.sc.cvv===undefined) ? '' : this.props.formValues.sc.cvv
    }

    render() {
        const { t, handleSubmit, change, untouch, invalid, submitting, pristine, from, touch } = this.props
        const filteredSC = this.filterSavedCard()
        return(
            <>
                <Form onSubmit={handleSubmit(this.payUsingSavedCard)} autoComplete='off'>
                    <FormGroup>
                        {
                            filteredSC && filteredSC.map((card, i)=> {
                                return (
                                <div key={i} className={`group-dd ${this.state.focus===card.hostedId ? 'activeBorder' : ''}`}>
                                    <Row>
                                        <Col className="mob-cardPanel" xs="12" md="8">
                                            <div className="cardType-dd">
                                            <CardImage cardType={card.name} />
                                            </div>
                                            <div className="numField">{formatCardWithSpace(card.alias)}</div>
                                        </Col>
                                        <Col className="mob-cvvPanel" xs="12" md="4">
                                            <Field maxLength={cvvMaxLength(this.state.cardScheme)} className="text-center form-control"
                                                name={`cvv${i}`}
                                                onDrop={onDropAlphawithsinglespace}
                                                normalize={(value) => numberAndUpdateCvv(value, this.updateCvv, this.getCvv)}
                                                onFocus={(e)=> this.clearAllInput(card.hostedId) }
                                                onBlur={()=>this.setState({focus: false})}
                                                onChange={(e) => this.currentCard(e.target.value, card)}
                                                component='input'
                                                type="text"  placeholder="CVV"
                                                autoComplete="off"
                                                onPaste={avoidPasting}
                                            />
                                            { this.state.enableDelete && <span className="icon-bin" onClick={() => this.handleDelete(card)}></span> } 
                                        </Col>
                                    </Row>
                                </div>
                                )
                            })
                        }
                    </FormGroup>
                    <Field type='hidden' name="sc[cvv]" maxLength={3} component='input' />
                    <Field type='hidden' name="sc[hostedId]" component='input' />
                    <Field type='hidden' name="cardNo" component='input' />
                    {
                        from==='EMISC' && (
                            <>
                                <Field name="bankName" type='hidden' component="input" />
                                <Field name="bankCode" type='hidden' component="input" />
                                <Field type='hidden' name="sc[emiTenure]" component='input' />
                            </>
                        )
                    }
                    {
                        this.props.from==='SC' &&
                        <> 
                        <div className="add-remove-panel">
                            <NavLink className="underline-text" href="#" onClick={() => this.props.changePayment("CREDITCARD_FROM_SC")}>{t('add_card')}</NavLink>
                        </div>
                        <div className="add-remove-panel">
                            <NavLink className={`underline-text mb-5 ${this.state.isActive && 'activeColor'}`} onClick={this.toggleDelete} href="#">{t('remove_card')}</NavLink>
                        </div>
                        </>
                    }
                    {
                        this.props.from==='EMISC' &&
                        <div className="add-remove-panel">
                            <NavLink className="link-14 p-0" onClick={this.props.showNewCard} href="#">{t('add_card')}</NavLink>
                        </div>
                    }
                    { this.canDisplaySICheckbox() && !this.state.dccEnabled &&
                        <SaveCardAutoInfo 
                            t={t} 
                            checked={this.state.siEnabled}
                            onChange={this.handleSiEnabledChecked}
                        />
                    }
                    <SIBtnORBtn disabled={invalid|| submitting || pristine || !this.state.cardMetaData || this.state.loader || !this.props.termsStatus } t={t}
                        change={change}
                        untouch={untouch}
                        touch={touch}
                        formValues={this.props.formValues}
                        cardMetaData={this.state.cardMetaData}
                        siEnabled={this.state.siEnabled}
                        from={this.props.from}
                        transactionDetails={this.props.transactionDetails}
                        btnName={this.props.btnName}
                        dccEnabled={this.state.dccEnabled}
                        dccCard={this.state.dccCard}
                    />
                </Form>
                { this.state.deleteConfirm && 
                <DeleteModal modalClassName="custom-otp-popup delete-popup" deleteSavedCard={this.deleteSavedCard} selectedDeleteCard={this.state.selectedDeleteCard} />}
                { this.state.displayError &&  <DisplayError errMsg={this.state.errMsg} /> }
                { this.state.loader &&  <GlobalLoaderModal transaction={this.state.redirectingTOBank} /> }
                { this.state.selfOTPBin && <OTPModal paymentResponse={this.state.paymentResponse} selfOTPTermUrl={this.state.selfOTPTermUrl} modalClassName="custom-otp-popup errorInvalid-popup" closeSelfOTP={this.closeSelfOTP} change={change} /> }
                <div className='hidden'>
                    <RenderForm is3DSecure={this.state.is3DSecure} isRupayCard={this.state.isRupayCard} threeDSecureRequest={this.state.threeDSecureRequest} rupayCardRequestBean={this.state.rupayCardRequestBean} formName={this.props.from} non3DSecure={this.state.non3DSecure} non3DSecureUrl={this.state.non3DSecureUrl} />
                </div>
            </>
        );
    }
}

const SCContent = reduxForm({
    form: 'scForm',
    validate: scFormValidation
})(SavedCardForm)

const mapStateToProps = state => {
    const formValues = getFormValues("scForm")(state) || {};
    const {termsStatus, savedCards, transactionDetails, txnKey, txnIv, siEnabled, globalConfig } = state.fdData
    return { termsStatus,savedCards, transactionDetails, txnKey, txnIv, siEnabled, globalConfig, initialValues: {sc: {}, standingInst: {sIAmtType: ''}}, formValues }
}

export default connect(mapStateToProps, { callDeleteSavedCard, callSetPayment })(SCContent);